<style lang="less" scoped>
.item {
  display: inline-block;
  margin-right: 8px;
}
.table-btn {
  font-size: 9px;
  height: 20px;
  line-height: 5.5px;
}
</style>

<template>
  <div class="table-container">
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
      :height="tableConfig.maxHeight"
      :header-cell-style="tableConfig.herderStyle"
    >
      <el-table-column
        v-if="tableConfig.showSelection"
        type="selection"
        width="40"
        align="center"
      >
      </el-table-column>
      <el-table-column
        v-if="tableConfig.showIndex"
        type="index"
        width="40"
        align="center"
      >
      </el-table-column>
      <template v-for="(column, index) in tableColumns">
        <el-table-column
          :key="index"
          :prop="column.props"
          :label="column.label"
          :width="column.width"
          :fixed="column.fixed"
          :align="column.align || 'center'"
          :min-width="column.minWidth"
          :show-overflow-tooltip="column.tooltip"
        >
          <template slot-scope="scope">
            <template v-if="column.formatter">
              <span v-html="column.formatter(scope.row, column)"></span>
            </template>

            <template v-else>
              <span>{{ scope.row[column.props] }}</span>
            </template>
          </template>
        </el-table-column>
      </template>
      <el-table-column
        ref="fixedColumn"
        label="操作"
        align="center"
        :width="operates.width"
        :fixed="operates.fixed"
        v-if="operates.list.filter((_x) => _x.show === true).length > 0"
      >
        <template slot-scope="scope">
          <div class="operate-group">
            <template v-for="(btn, key) in operates.list">
              <div class="item" v-if="btn.show" :key="btn.id">
                <template
                  v-if="
                    btn.id === 'tariff' ||
                      btn.id === 'replenishment' ||
                      btn.id === 'feedforward'
                  "
                >
                  <el-button
                    v-if="scope.row.v2gStationCode !== ''"
                    class="table-btn"
                    :type="btn.type"
                    size="mini"
                    :disabled="btn.disabled"
                    plain
                    @click.native.prevent="btn.method(key, scope.row)"
                    >{{ btn.label }}</el-button
                  >
                </template>
                <template v-else>
                  <el-button
                    class="table-btn"
                    :type="btn.type"
                    size="mini"
                    :disabled="btn.disabled"
                    plain
                    @click.native.prevent="btn.method(key, scope.row)"
                    >{{ btn.label }}</el-button
                  >
                </template>
              </div>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "ZDTable",
  props: {
    tableColumns: {
      type: Array,
      default: [],
    },
    tableData: {
      type: Array,
      default: [],
    },
    tableConfig: {
      type: Object,
      default: {},
    },
    operates: {},
  },
  data() {
    return {};
  },
  methods: {
    init() {},
    handleSelectionChange(e) {
      this.$emit("updateSelections", e);
    },
  },
  mounted() {
    this.init();
  },
};
</script>
